import React from 'react';
import classNames from 'classnames';
import { bool, string } from 'prop-types';
import { Typography } from '@fiverr-private/typography';
import { getContext } from '@fiverr-private/fiverr_context';
import { createClickedElement, trackGigForClickType } from '../../../utils';
import { ELEMENTS_NAME, ELEMENTS_TYPE } from '../../../Components/constants';
import { useCardContext } from '../../../../GigCardListings/context/CardContext';
import { isInExperimentGroup } from '../../../../GigCardListings/ListingsTransformer/abTestsTransformer';
import { ALLOCATIONS, EXPERIMENTS, ROLLOUTS } from '../../../../constants/experiments';
import { useRolloutsContext } from '../../../../GigCardListings/context/RolloutsContext/RolloutsContext';
import ContextualLink from '../../../Components/ContextualLink';
import { FiverrAdLbl } from './FiverrAdLbl/FiverrAdLbl';

import { sellerNameWrapperStyle, sellerNameLinkStyle } from './SellerName.ve.css';
import { FiverrAdRightLbl } from './FiverrAdLbl/FiverrAdRightLbl';

const clickedElement = (title) => createClickedElement(ELEMENTS_NAME.SELLER_TITLE, ELEMENTS_TYPE.LINK, title);

export const SellerName = ({ username, displayName, url, urlTarget, isPromotedGig, faUrl }) => {
    const {
        enrichedTracker: { trackEvent },
    } = useCardContext();

    const { rollouts } = useRolloutsContext();
    const {
        abTests,
        experience: { isBusiness },
    } = getContext();

    const isInTestGroup = isInExperimentGroup(EXPERIMENTS.BULLS_AD_LABEL_FULL_CATALOG, [ALLOCATIONS.TEST_B], abTests);
    const isInRollout = rollouts[ROLLOUTS.BULLS_AD_LABEL_FULL_CATALOG];
    const shouldShowLabelToTheRight = !isBusiness || (isInTestGroup && isInRollout);
    const sellerTitle = displayName ? displayName : username;

    return (
        <span className={classNames('p-r-24', sellerNameWrapperStyle)}>
            {!shouldShowLabelToTheRight && <FiverrAdLbl isPromoted={isPromotedGig} />}
            <ContextualLink
                className={classNames('text-bold', sellerNameLinkStyle)}
                href={url}
                rel="nofollow noopener noreferrer"
                target={urlTarget}
                onMouseDown={(e) => trackGigForClickType(e.button, trackEvent, clickedElement(sellerTitle))}
            >
                <Typography
                    color={{ hover: 'grey_1200', default: 'grey_1200' }}
                    decoration={{ hover: 'underline', default: 'none' }}
                    lineHeight="b_sm"
                    as="span"
                    display="block"
                    title={sellerTitle}
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    overflow="hidden"
                >
                    {sellerTitle}
                </Typography>
            </ContextualLink>
            {shouldShowLabelToTheRight && <FiverrAdRightLbl isPromoted={isPromotedGig} faUrl={faUrl} />}
        </span>
    );
};

SellerName.propTypes = {
    username: string,
    displayName: string,
    url: string,
    urlTarget: string,
    isPromotedGig: bool,
    faUrl: string,
};
